import { Pipe, PipeTransform } from "@angular/core";
import { SEND_TYPES } from "app/app-config";

export const productStyle = {
  [SEND_TYPES.SMS]: {
    icon: "fa-solid fa-comment-sms",
    color: "bg-light-info",
    bg: "sms-color sms-bg",
  },
  [SEND_TYPES.WHATSAPP]: {
    icon: "fa-brands fa-whatsapp",
    color: "bg-light-success",
    bg: "whatsapp-color whatsapp-bg",
  },
  [SEND_TYPES.EMAIL]: {
    icon: "fa-regular fa-bell",
    color: "bg-light-primary",
    bg: "email-color email-bg",
  },
  [SEND_TYPES.PUSH]: {
    icon: "fa-regular fa-envelope",
    color: "bg-light-secondary",
    bg: "#F2E7DF",
  },
};

@Pipe({
  name: "sendTypeColor",
})
export class SendTypeColorPipe implements PipeTransform {
  transform(value: keyof typeof SEND_TYPES): string {
    return productStyle[value].color;
  }
}

@Pipe({
  name: "sendTypeIcon",
})
export class SendTypeIconPipe implements PipeTransform {
  transform(value: keyof typeof SEND_TYPES): string {
    return productStyle[value].icon;
  }
}
